"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8225],{

/***/ 7558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrgIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);




function OrgIcon(props) {
    var size = props.size, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        src: "/assets/icons/org.svg",
        width: size || 24,
        height: size || 24
    }, restProps));
};


/***/ }),

/***/ 21291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EAS_EASVerificationModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
;// CONCATENATED MODULE: ./src/components/LinearBorderBox.tsx





var getBorderWitdh = function(width) {
    if (typeof width === "number") {
        return "".concat(width, "px");
    }
    return width;
};
var BorderBox = (0,src/* styled */.zop)(src/* Box */.xuv, {
    shouldForwardProp: function(p) {
        return p !== "borderWidth" && p !== "borderColor" && p !== "background";
    }
})(function(param) {
    var palette = param.theme.palette, borderWidth = param.borderWidth, borderColor = param.borderColor, background = param.background;
    var ref, ref1;
    return {
        // background color , border color
        backgroundImage: "linear-gradient(to right, ".concat(background || ((ref = palette.bg) === null || ref === void 0 ? void 0 : ref[0]), ", ").concat(background || ((ref1 = palette.bg) === null || ref1 === void 0 ? void 0 : ref1[0]), "), ").concat(borderColor),
        backgroundClip: "padding-box, border-box",
        backgroundOrigin: "padding-box, border-box",
        border: "".concat(borderWidth, " solid transparent")
    };
});
function LinearBorderBox(props) {
    var _borderRadius = props.borderRadius, borderRadius = _borderRadius === void 0 ? 1 : _borderRadius, _borderWidth = props.borderWidth, borderWidth = _borderWidth === void 0 ? 1 : _borderWidth, _borderColor = props.borderColor, borderColor = _borderColor === void 0 ? "linear-gradient(138deg,#B1E8DB, #0DB48C6E, #93EDD8F7, #0DB48C00)" : _borderColor, background = props.background, children = props.children, boxProps = (0,_object_without_properties/* default */.Z)(props, [
        "borderRadius",
        "borderWidth",
        "borderColor",
        "background",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BorderBox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        borderRadius: borderRadius,
        borderWidth: getBorderWitdh(borderWidth),
        borderColor: borderColor,
        background: background
    }, boxProps), {
        children: children
    }));
}
/* harmony default export */ var components_LinearBorderBox = (LinearBorderBox);

// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
// EXTERNAL MODULE: ../../packages/pwa-icons/index.ts + 1 modules
var pwa_icons = __webpack_require__(78221);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(13091);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(33927);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(42921);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Profile/EAS/EASBadge.tsx



function EASBadge(props) {
    var type = props.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kCb, {
        alignItems: "center",
        justifyContent: "center",
        sx: {
            ">span": {
                overflow: "visible !important"
            }
        },
        mt: -6,
        mb: 2,
        borderRadius: 100,
        position: "relative",
        width: 80,
        height: 80,
        boxShadow: props.boxShadow,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            priority: true,
            quality: 100,
            src: "/assets/logos/eas-".concat(type, ".png"),
            layout: "fill",
            style: {
                transform: "scale(1.5)",
                zIndex: 0
            }
        })
    });
}
/* harmony default export */ var EAS_EASBadge = (EASBadge);

// EXTERNAL MODULE: ./src/components/Icons/OrgIcon.tsx
var OrgIcon = __webpack_require__(7558);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 16 modules
var format = __webpack_require__(62650);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(41410);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/Profile/EAS/Info.tsx







var getEASExplorerDomain = function() {
    return  false ? 0 : "https://base.easscan.org/attestation/view/";
};
var InfoItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kCb, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                color: "text.250",
                variant: "caption",
                children: props.title
            }),
            props.children
        ]
    });
};
var isOrgVerified = function(refID) {
    return !!refID && refID !== "0x0000000000000000000000000000000000000000000000000000000000000000";
};
function EASInfo(props) {
    var ref, ref1, ref2, ref3;
    var attestation = props.attestation, type = props.type, orgName = props.orgName;
    var attestationData = (0,react.useMemo)(function() {
        var ref;
        if (!(attestation === null || attestation === void 0 ? void 0 : (ref = attestation.data) === null || ref === void 0 ? void 0 : ref.decodedDataJson)) return null;
        try {
            var parsedData = JSON.parse(attestation.data.decodedDataJson);
            return parsedData.reduce(function(result, item) {
                result[item.name] = item.value.value;
                return result;
            }, {});
        } catch (error) {
            return null;
        }
    }, [
        attestation === null || attestation === void 0 ? void 0 : (ref = attestation.data) === null || ref === void 0 ? void 0 : ref.decodedDataJson
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
        gap: 3,
        width: "100%",
        zIndex: 2,
        children: [
            (attestation === null || attestation === void 0 ? void 0 : attestation.type) === graphql/* Attestation_Type.Kol */.$GA.Kol ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoItem, {
                title: "Twitter Handle",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kCb, {
                    gap: 0.5,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xvT, {
                        children: [
                            "@",
                            attestationData === null || attestationData === void 0 ? void 0 : attestationData.twitterHandle
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoItem, {
                title: "Organization",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kCb, {
                    gap: 0.5,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                            children: orgName
                        }),
                        " ",
                        isOrgVerified(attestation === null || attestation === void 0 ? void 0 : (ref1 = attestation.data) === null || ref1 === void 0 ? void 0 : ref1.refUID) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrgIcon/* default */.Z, {
                            size: 18
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoItem, {
                title: "Verification Date",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                    children: (attestation === null || attestation === void 0 ? void 0 : (ref2 = attestation.data) === null || ref2 === void 0 ? void 0 : ref2.timeCreated) ? (0,format/* default */.Z)((0,fromUnixTime/* default */.Z)(attestation === null || attestation === void 0 ? void 0 : (ref3 = attestation.data) === null || ref3 === void 0 ? void 0 : ref3.timeCreated), "dd/MM/yyyy") : "-"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoItem, {
                title: "EAS Link",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    passHref: true,
                    href: "".concat(getEASExplorerDomain()).concat((attestation === null || attestation === void 0 ? void 0 : attestation.id) || ""),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xvT, {
                        width: "60%",
                        noWrap: true,
                        color: "text.link",
                        children: [
                            getEASExplorerDomain(),
                            (attestation === null || attestation === void 0 ? void 0 : attestation.id) || ""
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var Info = (EASInfo);

;// CONCATENATED MODULE: ./src/components/Profile/EAS/EASVerificationModal.tsx












var COLORS = {
    org: {
        border: "linear-gradient(138deg, #F8FAE5 14.38%, #CBB279 37.67%, #E9F0D7 61.38%, #957941 84.9%)",
        shadow: "0px 20px 50px 0px rgba(172, 145, 70, 0.30), 0px 10px 10px 0px rgba(172, 145, 70, 0.15)"
    },
    member: {
        border: "linear-gradient(138deg,#B1E8DB, #0DB48C6E, #93EDD8F7, #0DB48C00)",
        shadow: "0px 20px 50px 0px rgba(18, 182, 143, 0.30), 0px 10px 10px 0px rgba(18, 182, 143, 0.15)"
    }
};
var Title = function(props) {
    var type = props.type;
    if (!type) return null;
    if (type === graphql/* Attestation_Type.Kol */.$GA.Kol) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
            variant: "subtitle1",
            bold: true,
            color: "brand.main",
            children: "Verified X Creator"
        });
    }
    if ([
        graphql/* Attestation_Type.Member */.$GA.Member,
        graphql/* Attestation_Type.Email */.$GA.Email
    ].includes(type)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
        variant: "subtitle1",
        bold: true,
        color: "brand.main",
        children: "Verified Member"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
        width: "fit-content",
        variant: "subtitle1",
        bold: true,
        sx: {
            backgroundClip: "text",
            backgroundImage: "linear-gradient(138deg, #FFD401 14.38%, #F9A500 84.9%)",
            color: "transparent"
        },
        children: "Verified Organzaition"
    });
};
function EASVerificationModal(props) {
    var _type = props.type, type = _type === void 0 ? "member" : _type, attestation = props.attestation, orgName = props.orgName, modalProps = (0,_object_without_properties/* default */.Z)(props, [
        "type",
        "attestation",
        "orgName"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        PaperProps: {
            sx: {
                bgcolor: "transparent",
                background: "none",
                m: 0,
                px: 3,
                overflow: "visible"
            }
        }
    }, modalProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
            width: "calc(100vw - 48px)",
            position: "relative",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LinearBorderBox, {
                    width: "100%",
                    borderColor: COLORS[type].border,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                        alignItems: "center",
                        gap: 3,
                        p: 3,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EAS_EASBadge, {
                                boxShadow: COLORS[type].shadow,
                                type: type
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                type: attestation.type
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Info, {
                                attestation: attestation,
                                type: type,
                                orgName: orgName
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-close-circle-line",
                    mt: 3,
                    onClick: modalProps.onClose
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    position: "absolute",
                    bottom: 48,
                    left: 0,
                    width: "100%",
                    height: 167,
                    zIndex: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: "/assets/bg/eas-bg-".concat(type, ".svg"),
                        layout: "fill"
                    })
                })
            ]
        })
    }));
}
/* harmony default export */ var EAS_EASVerificationModal = (EASVerificationModal);


/***/ }),

/***/ 49054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ sectors; },
/* harmony export */   "Oj": function() { return /* binding */ DEFAULT_BLOCK_TITLE; },
/* harmony export */   "c6": function() { return /* binding */ chainData; },
/* harmony export */   "ex": function() { return /* binding */ BLOCK_VERIFICATION_EMAIL_HASH; },
/* harmony export */   "pn": function() { return /* binding */ KOL_TWITTER_FOLLOWER_COUNT_THRESHOLD; }
/* harmony export */ });
/* unused harmony export ChainType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51499);


var KOL_TWITTER_FOLLOWER_COUNT_THRESHOLD =  true ? 5000 : 0;
var _obj;
var DEFAULT_BLOCK_TITLE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Contact */ .kHU.Contact, "Contact"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Credential */ .kHU.Credential, "Credentials Showcase"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Education */ .kHU.Education, "Education"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.WorkExperience */ .kHU.WorkExperience, "Work Experience"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.NftCollection */ .kHU.NftCollection, "NFT Collection"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.NftGallery */ .kHU.NftGallery, "NFT Gallery"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Posts */ .kHU.Posts, "Post"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Event */ .kHU.Event, "Event"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Snapshot */ .kHU.Snapshot, "Snapshot Proposals"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Skill */ .kHU.Skill, "Skills"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Superlink */ .kHU.Superlink, "Featured Content"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Link */ .kHU.Link, "Official Links"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.W3StGallery */ .kHU.W3StGallery, "My W3ST"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Twitter */ .kHU.Twitter, "Other Showcase"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .BlockType.Recommendation */ .kHU.Recommendation, "Recommendations"), _obj);
var sectors = [
    "NFT",
    "Identity",
    "Game",
    "DeFi",
    "Social",
    "Infrastructure",
    "Tool",
    "Wallet",
    "Metaverse",
    "DAO",
    "Blockchain", 
];
var ChainType;
(function(ChainType) {
    ChainType["eth"] = "eth";
    ChainType["polygon"] = "polygon";
    ChainType["bnb"] = "bnb";
    ChainType["optimism"] = "optimism";
    ChainType["arbitrum"] = "arbitrum";
    ChainType["fantom"] = "fantom";
    ChainType["avalanche"] = "avalanche";
    ChainType["gnosis"] = "gnosis";
    ChainType["solana"] = "solana";
    ChainType["Terra"] = "Terra";
    ChainType["Near"] = "Near";
    ChainType["Polkadot"] = "Polkadot";
    ChainType["Kusama"] = "Kusama";
    ChainType["Cardano"] = "Cardano";
    ChainType["Cosmos"] = "Cosmos";
    ChainType["Tron"] = "Tron";
    ChainType["Algorand"] = "Algorand";
    ChainType["Stellar"] = "Stellar";
    ChainType["Flow"] = "Flow";
    ChainType["EOS"] = "EOS";
    ChainType["Harmony"] = "Harmony";
    ChainType["Neo"] = "Neo";
    ChainType["Zilliqa"] = "Zilliqa";
    ChainType["Enjin"] = "Enjin";
    ChainType["Loopring"] = "Loopring";
    ChainType["ImmutableX"] = "ImmutableX";
    ChainType["Ronin"] = "Ronin";
    ChainType["Celo"] = "Celo";
    ChainType["Moonbeam"] = "Moonbeam";
    ChainType["Palm"] = "Palm";
    ChainType["Caduceus"] = "Caduceus";
    ChainType["ZkSync"] = "ZkSync";
    ChainType["Aptos"] = "Aptos";
    ChainType["Sui"] = "Sui";
    ChainType["StarkNet"] = "StarkNet";
    ChainType["Shardeum"] = "Shardeum";
    ChainType["ArbitrumNova"] = "Arbitrum Nova";
    ChainType["haqq"] = "haqq";
    ChainType["metis"] = "Metis";
    ChainType["injective"] = "Injective";
    ChainType["mantle"] = "Mantle";
    ChainType["scroll"] = "Scroll";
    ChainType["base"] = "Base";
    ChainType["sei"] = "Sei";
    ChainType["astar"] = "Astar";
})(ChainType || (ChainType = {}));
var _obj1;
var chainData = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.eth, {
    name: "Ethereum",
    icon: "/assets/blockchainIcons/Eth.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.polygon, {
    name: "Polygon",
    icon: "/assets/blockchainIcons/Polygon.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.bnb, {
    name: "BNB Chain",
    icon: "/assets/blockchainIcons/Bnb.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.optimism, {
    name: "Optimism",
    icon: "/assets/blockchainIcons/Optimism.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.arbitrum, {
    name: "Arbitrum One",
    icon: "/assets/blockchainIcons/Arbitrum.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.ArbitrumNova, {
    name: "Arbitrum Nova",
    icon: "/assets/blockchainIcons/Arbitrum_Nova.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.fantom, {
    name: "Fantom",
    icon: "/assets/blockchainIcons/Fantom.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.avalanche, {
    name: "Avalanche",
    icon: "/assets/blockchainIcons/Avalanche.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.gnosis, {
    name: "Gnosis chain",
    icon: "/assets/blockchainIcons/Gnosis.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.solana, {
    name: "Solana",
    icon: "/assets/blockchainIcons/Solana.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Terra, {
    name: "Terra",
    icon: "/assets/blockchainIcons/Terra.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Near, {
    name: "Near",
    icon: "/assets/blockchainIcons/Near.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Polkadot, {
    name: "Polkadot",
    icon: "/assets/blockchainIcons/Polkadot.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Kusama, {
    name: "Kusama",
    icon: "/assets/blockchainIcons/Kusama.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Cardano, {
    name: "Cardano",
    icon: "/assets/blockchainIcons/Cardano.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Cosmos, {
    name: "Cosmos",
    icon: "/assets/blockchainIcons/Cosmos.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Tron, {
    name: "Tron",
    icon: "/assets/blockchainIcons/Tron.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Algorand, {
    name: "Algorand",
    icon: "/assets/blockchainIcons/Algorand.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Flow, {
    name: "Flow",
    icon: "/assets/blockchainIcons/Flow.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.EOS, {
    name: "EOS",
    icon: "/assets/blockchainIcons/Eos.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Harmony, {
    name: "Harmony",
    icon: "/assets/blockchainIcons/Harmony.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Neo, {
    name: "Neo",
    icon: "/assets/blockchainIcons/Neo.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Zilliqa, {
    name: "Zilliqa",
    icon: "/assets/blockchainIcons/Zilliqa.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Enjin, {
    name: "Enjin",
    icon: "/assets/blockchainIcons/Enjin.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Loopring, {
    name: "Looprin",
    icon: "/assets/blockchainIcons/Loopring.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.ImmutableX, {
    name: "ImmutableX",
    icon: "/assets/blockchainIcons/ImmutableX.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Ronin, {
    name: "Ronin",
    icon: "/assets/blockchainIcons/Ronin.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Celo, {
    name: "Celo",
    icon: "/assets/blockchainIcons/Celo.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Moonbeam, {
    name: "Moonbeam",
    icon: "/assets/blockchainIcons/Moonbeam.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Palm, {
    name: "Palm",
    icon: "/assets/blockchainIcons/Palm.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Caduceus, {
    name: "Caduceus",
    icon: "/assets/blockchainIcons/Caduceus.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.ZkSync, {
    name: "ZkSync",
    icon: "/assets/blockchainIcons/ZkSync.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Aptos, {
    name: "Aptos",
    icon: "/assets/blockchainIcons/Aptos.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Sui, {
    name: "Sui",
    icon: "/assets/blockchainIcons/Sui.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.StarkNet, {
    name: "StarkNet",
    icon: "/assets/blockchainIcons/StarkNet.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.Shardeum, {
    name: "Shardeum",
    icon: "/assets/blockchainIcons/Shardeum.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.haqq, {
    name: "HAQQ",
    icon: "/assets/blockchainIcons/haqq.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.metis, {
    name: "Metis",
    icon: "/assets/blockchainIcons/metis.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.injective, {
    name: "Injective",
    icon: "/assets/blockchainIcons/injective.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.mantle, {
    name: "Mantle",
    icon: "/assets/blockchainIcons/mantle.webp"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.scroll, {
    name: "Scroll",
    icon: "/assets/blockchainIcons/scroll.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.base, {
    name: "Base",
    icon: "/assets/blockchainIcons/base.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.sei, {
    name: "Sei",
    icon: "/assets/blockchainIcons/Sei.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ChainType.astar, {
    name: "Astar",
    icon: "/assets/blockchainIcons/Astar.png"
}), _obj1);
var BLOCK_VERIFICATION_EMAIL_HASH = {
    "@gmail.com": "Gmail",
    "@yahoo.com": "Yahoo",
    "@hotmail.com": "Hotmail",
    "@outlook.com": "Outlook",
    "@icloud.com": "iCloud",
    "@qq.com": "QQ",
    "@163.com": 163,
    "@126.com": 126,
    "@sina.com": "Sina",
    "@sohu.com": "Sohu",
    "@aol.com": "AOL",
    "@zoho.com": "Zoho",
    "@mail.com": "Mail.com",
    "@yandex.com": "Yandex",
    "@protonmail.com": "ProtonMail",
    "@gmx.com": "GMX",
    "@rediffmail.com": "Rediffmail",
    "@lycos.com": "Lycos",
    "@excite.com": "Excite",
    "@tutanota.com": "Tutanota",
    "@hushmail.com": "Hushmail"
};


/***/ }),

/***/ 61307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_eas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46209);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51499);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);








var isOrgProfile = function(data) {
    return (data === null || data === void 0 ? void 0 : data.type) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ProfileType.Organization */ .pqZ.Organization;
};
var isPerProfile = function(data) {
    return (data === null || data === void 0 ? void 0 : data.type) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ProfileType.Personal */ .pqZ.Personal;
};
var getAtestation = function(profileData) {
    if (isOrgProfile(profileData)) {
        return {
            attestation: profileData.organization.lightInfo.attestation,
            isVerified: profileData.organization.verification === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .VerificationStatus.Verified */ .$ZB.Verified
        };
    } else if (isPerProfile(profileData)) {
        return {
            attestation: profileData.owner.lightInfo.attestation,
            isVerified: profileData.owner.lightInfo.isVerified
        };
    } else {
        return {
            attestation: undefined,
            isVerified: false
        };
    }
};
function useEas(profileId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isClaiming = ref[0], toggleIsClaiming = ref[1];
    var ref1 = (0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .useEasAttestationQuery */ .UeG)((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .getProfileQueryParams */ .Vy)(profileId), {
        skip: !profileId,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData, isFetching = param.isFetching;
            var profileData = currentData === null || currentData === void 0 ? void 0 : currentData.profile.data;
            return getAtestation(profileData);
        },
        refetchOnMountOrArgChange: true
    }), attestation = ref1.attestation, isVerified = ref1.isVerified, refetch = ref1.refetch;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .useLazyEasAttestationQuery */ .s08)(), 1), queryEasStatus = ref2[0];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .useClaimEasAttestationMutation */ .wnu)(), 1), claimEASCaller = ref3[0];
    //   query eas data from eas endpoint by uid
    var atestationData = (0,_cyber_service_eas__WEBPACK_IMPORTED_MODULE_2__/* .useAttestationsQuery */ .Pt)({
        id: attestation === null || attestation === void 0 ? void 0 : attestation.uid
    }, {
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            return {
                atestationData: currentData === null || currentData === void 0 ? void 0 : currentData.getAttestation
            };
        },
        skip: !(attestation === null || attestation === void 0 ? void 0 : attestation.uid)
    }).atestationData;
    var checkEasStatus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return queryEasStatus((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .getProfileQueryParams */ .Vy)(profileId)).then(function(data) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                            var profileLightInfo = (ref1 = (ref = data.data) === null || ref === void 0 ? void 0 : ref.profile.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.owner) === null || ref2 === void 0 ? void 0 : ref2.lightInfo;
                            return(// only member can claim
                            {
                                couldClaim: (profileLightInfo === null || profileLightInfo === void 0 ? void 0 : (ref3 = profileLightInfo.attestation) === null || ref3 === void 0 ? void 0 : ref3.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Unclaimed */ ._dk.Unclaimed,
                                pendingClaim: (profileLightInfo === null || profileLightInfo === void 0 ? void 0 : (ref4 = profileLightInfo.attestation) === null || ref4 === void 0 ? void 0 : ref4.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Claiming */ ._dk.Claiming,
                                isClaimed: (profileLightInfo === null || profileLightInfo === void 0 ? void 0 : (ref5 = profileLightInfo.attestation) === null || ref5 === void 0 ? void 0 : ref5.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Claimed */ ._dk.Claimed,
                                claimedByOther: (profileLightInfo === null || profileLightInfo === void 0 ? void 0 : (ref6 = profileLightInfo.attestation) === null || ref6 === void 0 ? void 0 : ref6.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.ClaimedByOther */ ._dk.ClaimedByOther
                            });
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkEasStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var pollingEASStatus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var claimed, count;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        claimed = false;
                        count = 0;
                    case 2:
                        if (!(count > 20)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("break", 11);
                    case 4:
                        _ctx.next = 6;
                        return queryEasStatus((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .getProfileQueryParams */ .Vy)(profileId)).then(function(data) {
                            var ref, // only member can claim
                            ref1, ref2, ref3, ref4;
                            return ((ref1 = ((ref = data.data) === null || ref === void 0 ? void 0 : ref.profile.data)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.owner) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lightInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attestation) === null || ref4 === void 0 ? void 0 : ref4.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Claimed */ ._dk.Claimed;
                        });
                    case 6:
                        claimed = _ctx.sent;
                        _ctx.next = 9;
                        return (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .sleep */ ._v)(1000);
                    case 9:
                        count++;
                    case 10:
                        if (!claimed) {
                            _ctx.next = 2;
                            break;
                        }
                    case 11:
                        toggleIsClaiming(false);
                        return _ctx.abrupt("return", claimed);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function pollingEASStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var claimEAS = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, couldClaim, isClaimed, claimedByOther, ref1, isSuccess, status, claimed;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        toggleIsClaiming(true);
                        _ctx.next = 4;
                        return checkEasStatus();
                    case 4:
                        ref = _ctx.sent;
                        couldClaim = ref.couldClaim;
                        isClaimed = ref.isClaimed;
                        claimedByOther = ref.claimedByOther;
                        if (!isClaimed) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            isSuccess: true
                        });
                    case 10:
                        if (!claimedByOther) {
                            _ctx.next = 13;
                            break;
                        }
                        _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Amu.error("claimed by other");
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 13:
                        _ctx.next = 15;
                        return couldClaim ? claimEASCaller().then(function(data) {
                            return {
                                isSuccess: "data" in data && data.data.ClaimEasAttestation.Status === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ClaimEasAttestationResponse_Status.Success */ .dAd.Success,
                                status: "data" in data ? data.data.ClaimEasAttestation.Status : undefined
                            };
                        }) : {
                            isSuccess: true,
                            status: undefined
                        };
                    case 15:
                        ref1 = _ctx.sent;
                        isSuccess = ref1.isSuccess;
                        status = ref1.status;
                        if (!isSuccess) {
                            _ctx.next = 23;
                            break;
                        }
                        _ctx.next = 21;
                        return pollingEASStatus();
                    case 21:
                        claimed = _ctx.sent;
                        return _ctx.abrupt("return", {
                            isSuccess: claimed
                        });
                    case 23:
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 29:
                        _ctx.prev = 29;
                        toggleIsClaiming(false);
                        return _ctx.finish(29);
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    26,
                    29,
                    32
                ]
            ]);
        }));
        return function claimEAS() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        isVerified: isVerified && !!(attestation === null || attestation === void 0 ? void 0 : attestation.uid) && attestation.type !== _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Type.Member */ .$GA.Member,
        attestation: {
            data: atestationData,
            id: attestation === null || attestation === void 0 ? void 0 : attestation.uid,
            type: attestation === null || attestation === void 0 ? void 0 : attestation.type
        },
        attestationType: attestation === null || attestation === void 0 ? void 0 : attestation.type,
        couldClaim: (attestation === null || attestation === void 0 ? void 0 : attestation.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Unclaimed */ ._dk.Unclaimed && attestation.type !== _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Type.Member */ .$GA.Member,
        isClaiming: isClaiming || (attestation === null || attestation === void 0 ? void 0 : attestation.status) === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .Attestation_Status.Claiming */ ._dk.Claiming,
        claimEAS: claimEAS,
        refetch: refetch
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useEas);


/***/ }),

/***/ 51466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useModalState() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOpen = ref[0], toggleIsOpen = ref[1];
    var closeModal = function() {
        toggleIsOpen(false);
    };
    var openModal = function() {
        toggleIsOpen(true);
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useModalState);


/***/ }),

/***/ 46209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ useAttestationsQuery; }
/* harmony export */ });
/* unused harmony exports AttestationScalarFieldEnum, EnsNameScalarFieldEnum, OffchainRevocationScalarFieldEnum, QueryMode, SchemaNameScalarFieldEnum, SchemaScalarFieldEnum, ServiceStatScalarFieldEnum, SortOrder, TimestampScalarFieldEnum, AttestationsDocument, api, useLazyAttestationsQuery */
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80174);

var AttestationScalarFieldEnum;
(function(AttestationScalarFieldEnum) {
    AttestationScalarFieldEnum["Attester"] = "attester";
    AttestationScalarFieldEnum["Data"] = "data";
    AttestationScalarFieldEnum["DecodedDataJson"] = "decodedDataJson";
    AttestationScalarFieldEnum["ExpirationTime"] = "expirationTime";
    AttestationScalarFieldEnum["Id"] = "id";
    AttestationScalarFieldEnum["IpfsHash"] = "ipfsHash";
    AttestationScalarFieldEnum["IsOffchain"] = "isOffchain";
    AttestationScalarFieldEnum["Recipient"] = "recipient";
    AttestationScalarFieldEnum["RefUid"] = "refUID";
    AttestationScalarFieldEnum["Revocable"] = "revocable";
    AttestationScalarFieldEnum["RevocationTime"] = "revocationTime";
    AttestationScalarFieldEnum["Revoked"] = "revoked";
    AttestationScalarFieldEnum["SchemaId"] = "schemaId";
    AttestationScalarFieldEnum["Time"] = "time";
    AttestationScalarFieldEnum["TimeCreated"] = "timeCreated";
    AttestationScalarFieldEnum["Txid"] = "txid";
})(AttestationScalarFieldEnum || (AttestationScalarFieldEnum = {}));
var EnsNameScalarFieldEnum;
(function(EnsNameScalarFieldEnum) {
    EnsNameScalarFieldEnum["Id"] = "id";
    EnsNameScalarFieldEnum["Name"] = "name";
    EnsNameScalarFieldEnum["Timestamp"] = "timestamp";
})(EnsNameScalarFieldEnum || (EnsNameScalarFieldEnum = {}));
var OffchainRevocationScalarFieldEnum;
(function(OffchainRevocationScalarFieldEnum) {
    OffchainRevocationScalarFieldEnum["From"] = "from";
    OffchainRevocationScalarFieldEnum["Id"] = "id";
    OffchainRevocationScalarFieldEnum["Timestamp"] = "timestamp";
    OffchainRevocationScalarFieldEnum["Txid"] = "txid";
    OffchainRevocationScalarFieldEnum["Uid"] = "uid";
})(OffchainRevocationScalarFieldEnum || (OffchainRevocationScalarFieldEnum = {}));
var QueryMode;
(function(QueryMode) {
    QueryMode["Default"] = "default";
    QueryMode["Insensitive"] = "insensitive";
})(QueryMode || (QueryMode = {}));
var SchemaNameScalarFieldEnum;
(function(SchemaNameScalarFieldEnum) {
    SchemaNameScalarFieldEnum["AttesterAddress"] = "attesterAddress";
    SchemaNameScalarFieldEnum["Id"] = "id";
    SchemaNameScalarFieldEnum["IsCreator"] = "isCreator";
    SchemaNameScalarFieldEnum["Name"] = "name";
    SchemaNameScalarFieldEnum["SchemaId"] = "schemaId";
    SchemaNameScalarFieldEnum["Time"] = "time";
})(SchemaNameScalarFieldEnum || (SchemaNameScalarFieldEnum = {}));
var SchemaScalarFieldEnum;
(function(SchemaScalarFieldEnum) {
    SchemaScalarFieldEnum["Creator"] = "creator";
    SchemaScalarFieldEnum["Id"] = "id";
    SchemaScalarFieldEnum["Index"] = "index";
    SchemaScalarFieldEnum["Resolver"] = "resolver";
    SchemaScalarFieldEnum["Revocable"] = "revocable";
    SchemaScalarFieldEnum["Schema"] = "schema";
    SchemaScalarFieldEnum["Time"] = "time";
    SchemaScalarFieldEnum["Txid"] = "txid";
})(SchemaScalarFieldEnum || (SchemaScalarFieldEnum = {}));
var ServiceStatScalarFieldEnum;
(function(ServiceStatScalarFieldEnum) {
    ServiceStatScalarFieldEnum["Name"] = "name";
    ServiceStatScalarFieldEnum["Value"] = "value";
})(ServiceStatScalarFieldEnum || (ServiceStatScalarFieldEnum = {}));
var SortOrder;
(function(SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder || (SortOrder = {}));
var TimestampScalarFieldEnum;
(function(TimestampScalarFieldEnum) {
    TimestampScalarFieldEnum["From"] = "from";
    TimestampScalarFieldEnum["Id"] = "id";
    TimestampScalarFieldEnum["Timestamp"] = "timestamp";
    TimestampScalarFieldEnum["Tree"] = "tree";
    TimestampScalarFieldEnum["Txid"] = "txid";
})(TimestampScalarFieldEnum || (TimestampScalarFieldEnum = {}));
var AttestationsDocument = "\n    query attestations($id: String!) {\n  getAttestation(where: {id: $id}) {\n    id\n    revoked\n    recipient\n    attester\n    decodedDataJson\n    timeCreated\n    refUID\n  }\n}\n    ";
var injectedRtkApi = _client__WEBPACK_IMPORTED_MODULE_0__/* .api.injectEndpoints */ .h.injectEndpoints({
    endpoints: function(build) {
        return {
            attestations: build.query({
                query: function(variables) {
                    return {
                        document: AttestationsDocument,
                        variables: variables
                    };
                }
            })
        };
    }
});

var useAttestationsQuery = injectedRtkApi.useAttestationsQuery, useLazyAttestationsQuery = injectedRtkApi.useLazyAttestationsQuery;


/***/ })

}]);